
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-menu/[cName]/product/[productId]",
      function () {
        return require("private-next-pages/embedded-menu/[cName]/product/[productId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-menu/[cName]/product/[productId]"])
      });
    }
  